import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["treatment"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback } from 'react';
import styled, { useTheme } from 'styled-components';
import { Box, Image } from '@miro-site/core';
import { ItemContainer, ItemLink, ItemDescription, Container, Headline, ViewAllLink, Item } from './Highlighted';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var HERO_IMAGE = 'https://images.ctfassets.net/qop92tnevinq/1T3F2z5K3V3nxeJfzJHFLn/b676070f4202b95e6144ab8656adc74f/website_logo_jake_3x.png';
var HERO_LINK = '/miroverse/design-sprint-jake-knapp/';
var MIROVERSE_PROFILES_IMAGE = 'https://images.ctfassets.net/qop92tnevinq/7B4JST2nqmYadshYohiscl/0bb93ae9446a76792853b271bc200553/miroverse_banner_faces_3x.png';
var MIROVERSE_LINK = '/miroverse/';
var HeroBannerLink = styled(ItemLink).withConfig({
  displayName: "HeroBannerHighlighted__HeroBannerLink",
  componentId: "sc-1j51fyt-0"
})(["margin-bottom:0px;"]);
var BoldText = styled(Box).attrs({
  as: 'span',
  $styles: {
    fontWeight: 'bold'
  }
}).withConfig({
  displayName: "HeroBannerHighlighted__BoldText",
  componentId: "sc-1j51fyt-1"
})([""]); // HeroBannerV1 or HeroBannerV2 will be promoted to HeroBanner if experiment is successful

var HeroBannerV1 = function HeroBannerV1() {
  var theme = useTheme();
  return /*#__PURE__*/_jsx(HeroBannerLink, {
    target: "_blank",
    href: MIROVERSE_LINK,
    $mb: theme.header.highlighted.margins.afterItem,
    children: /*#__PURE__*/_jsx(ItemContainer, {
      children: /*#__PURE__*/_jsx(Box, {
        $mr: theme.header.highlighted.margins.afterImage,
        $styles: {
          width: theme.header.highlighted.imageWidthV1
        },
        children: /*#__PURE__*/_jsx(Image, {
          name: "miroverse-profiles",
          "aria-hidden": true,
          src: MIROVERSE_PROFILES_IMAGE
        })
      })
    })
  });
};

var HeroBannerV2 = function HeroBannerV2() {
  var theme = useTheme();
  return /*#__PURE__*/_jsx(ItemLink, {
    target: "_blank",
    href: HERO_LINK,
    $mb: theme.header.highlighted.margins.afterItem,
    children: /*#__PURE__*/_jsxs(ItemContainer, {
      children: [/*#__PURE__*/_jsx(Box, {
        $mr: theme.header.highlighted.margins.afterImage,
        $styles: {
          width: theme.header.highlighted.imageWidthV2
        },
        children: /*#__PURE__*/_jsx(Image, {
          name: "jake",
          "aria-hidden": true,
          src: HERO_IMAGE
        })
      }), /*#__PURE__*/_jsx(Box, {
        $styles: {
          width: theme.header.highlighted.textWidthV2
        },
        children: /*#__PURE__*/_jsxs(ItemDescription, {
          children: [/*#__PURE__*/_jsx(BoldText, {
            children: "Jake Knapp"
          }), "\xA0is the inventor of ", /*#__PURE__*/_jsx(BoldText, {
            children: "the Design Sprint"
          }), " and shared his knowledge with Miro users."]
        })
      })]
    })
  });
};

var PopularTemplates = function PopularTemplates(props) {
  var title = props.title,
      items = props.items,
      showAllLink = props.showAllLink;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Headline, {
      children: title
    }), /*#__PURE__*/_jsx("ul", {
      children: items.map(function (item) {
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(Item, _objectSpread({}, item))
        }, item.title);
      })
    }), /*#__PURE__*/_jsx(ViewAllLink, {
      href: showAllLink.path,
      children: showAllLink.title
    })]
  });
};

var HeroBannerHighlighted = function HeroBannerHighlighted(props) {
  var treatment = props.treatment,
      rest = _objectWithoutProperties(props, _excluded);

  var getContent = useCallback(function () {
    var treatments = {
      v1: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Headline, {
          children: "Explore community templates"
        }), /*#__PURE__*/_jsx(HeroBannerV1, {}), /*#__PURE__*/_jsx(ViewAllLink, {
          target: "_blank",
          href: MIROVERSE_LINK,
          children: "View in Miroverse"
        })]
      }),
      v2: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Headline, {
          children: "Explore community templates"
        }), /*#__PURE__*/_jsx(HeroBannerV2, {}), /*#__PURE__*/_jsx(ViewAllLink, {
          target: "_blank",
          href: HERO_LINK,
          children: "View \u2019Design Sprint\u2019 template"
        })]
      })
    };
    return treatment && treatments[treatment] ? treatments[treatment] : /*#__PURE__*/_jsx(PopularTemplates, _objectSpread({}, rest));
  }, [treatment]);
  return /*#__PURE__*/_jsx(Container, {
    "data-track-place": "Hero Banner",
    children: getContent()
  });
};

export default Object.assign(HeroBannerHighlighted, {
  Item: Item
});